import { useId } from 'react';
import { useGT } from 'gt-react';
import { Switch } from '@/components/ui/switch';
import { useAgentState } from '@/context/agent-state.context';
import { useFollowAgent, useFollowTurn } from './useWorkbookFollow';

/** Renders nothing: pauses following when the user navigates during an agent turn. */
export function WorkbookFollowTurn({
  trackTurn,
  selection,
}: {
  trackTurn: (
    selection: string,
    agentBusy: boolean,
    replyId: string | null,
  ) => void;
  selection: string;
}) {
  const { isLoading, activeRequestId } = useAgentState();
  useFollowTurn(trackTurn, selection, isLoading, activeRequestId);
  return null;
}

/** Whether the page shows the tab the agent just changed. */
export function WorkbookFollowToggle() {
  const gt = useGT();
  const id = useId();
  const [following, setFollowing] = useFollowAgent();
  return (
    <div className="flex items-center gap-1.5 text-xs text-muted-foreground">
      <Switch
        id={id}
        checked={following}
        onCheckedChange={setFollowing}
        aria-label={gt('Follow agent', {
          context: 'workbook toggle: show the tab the agent is editing',
        })}
      />
      <label htmlFor={id}>
        {gt('Follow agent', {
          context: 'workbook toggle: show the tab the agent is editing',
        })}
      </label>
    </div>
  );
}
